import { seededRandomPrice } from '../utils/pricing';

const CRUISE_LINES = ['Ocean Pearl', 'Star Horizon', 'Royal Wave', 'Blue Meridian', 'Coral Queen', 'Atlantic Crown'];
const CABINS = ['Interior', 'Ocean View', 'Balcony', 'Suite'];
const REGIONS = ['Caribbean', 'Mediterranean', 'Alaska', 'Northern Europe', 'Asia Pacific', 'South America'];
const PORTS = ['Miami', 'Fort Lauderdale', 'Barcelona', 'Rome', 'Seattle', 'Southampton', 'Sydney', 'Singapore'];

function slug(text) {
  return text.toLowerCase().replace(/[^a-z0-9]+/g, '-');
}

function pick(arr, i) {
  return arr[i % arr.length];
}

function generateCruises(count = 1000) {
  return Array.from({ length: count }, (_, i) => {
    const nights = 5 + (i % 12);
    const price = seededRandomPrice(`cruise-${i}`);
    const port = pick(PORTS, i);
    const destination = pick(REGIONS, i);

    return {
      id: `cu-catalog-${i}`,
      line: pick(CRUISE_LINES, i),
      port,
      destination,
      portSlug: slug(port),
      regionSlug: slug(destination),
      nights,
      departDate: `2026-${String(6 + (i % 6)).padStart(2, '0')}-${String(5 + (i % 24)).padStart(2, '0')}`,
      price,
      cabin: pick(CABINS, i),
      source: 'catalog',
    };
  });
}

const cruises = generateCruises(1000);

export const CATALOG_STATS = {
  cruises: cruises.length,
};

export function getCruiseCatalog() {
  return cruises;
}
